import { type LucideIcon, Search } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from './utils';

interface InlineEmptyProps {
  icon?: LucideIcon;
  children: ReactNode;
  description?: ReactNode;
  className?: string;
}

export function InlineEmpty({
  icon: IconComponent = Search,
  children,
  description,
  className,
}: InlineEmptyProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-2 rounded-[10px] px-4 py-3',
        className,
      )}
    >
      <IconComponent className="size-7 text-v2-text-secondary" strokeWidth={1.5} />
      <div className="flex flex-col items-center gap-2">
        <span className="text-center text-[13px] leading-4 font-normal tracking-[-0.01em] text-v2-text-secondary">
          {children}
        </span>
        {description && (
          <span className="text-center text-[12px] leading-[1.4] font-normal text-v2-text-secondary/70">
            {description}
          </span>
        )}
      </div>
    </div>
  );
}
